export const root = state => state.getIn(['timeplanUnits']);
export const timeplanUnits = state => root(state).get('entities');
export const timeplanUnitById = (state, id) => timeplanUnits(state).get(String(id));
export const timeplanUnitsByIds = (state, ids) => ids.map(id => timeplanUnitById(state, id));
